import * as React from 'react';
import {
    Edit,
    required,
    SimpleForm,
    TextInput,
    SelectInput,
    ReferenceInput,
} from 'react-admin';
import TargetTitle from './TargetTitle';

const TargetEdit = props => (
    <Edit title={<TargetTitle />} {...props}>
        <SimpleForm>
            <ReferenceInput label="Instances" source="instance_id" reference="instances">
                <SelectInput source="name" validate={required()} />
            </ReferenceInput>
            <TextInput source="name" validate={required()} />
            <TextInput source="slug" validate={required()} />
            <TextInput source="type" validate={required()} />
            <TextInput source="account_name" />
            <TextInput source="account_key" />
        </SimpleForm>
    </Edit>
);

export default TargetEdit;